export const BOOL_ENTITY_TYPE = "Галочка";

export function isBoolEntityChecked(value: any): boolean {
    if (value === true) {
        return true;
    }
    const normalized = (value ?? "").toString().trim().toLowerCase();
    return normalized === "true" || normalized === "1" || normalized === "да";
}

export function boolEntityToValue(checked: boolean): string {
    return checked ? "true" : "false";
}

/** Нужно ли требовать установленную галочку (ответ «да»). По умолчанию — да, если поле обязательное. */
export function boolEntityRequiresChecked(entity: any): boolean {
    const isRequired = !("isRequired" in entity) || entity["isRequired"] === true;
    if (!isRequired) {
        return false;
    }
    if ("requireChecked" in entity) {
        return entity.requireChecked === true;
    }
    return true;
}

export function boolEntityTextValue(entity: any): string {
    const keyword = (entity?.keyword ?? "").trim();
    const label = boolEntityLabel(entity);
    if (!keyword) {
        return label;
    }
    return `${keyword}: ${label}`;
}

function boolEntityLabel(entity: any): string {
    return isBoolEntityChecked(entity?.value) ? "да" : "нет";
}

/** Текст для подстановки в тело договора (PDF, редактор текста). */
export function boolEntityOmitsContractText(entity: any): boolean {
    return !!(entity?.hideNoInDocument && !isBoolEntityChecked(entity?.value));
}

export function boolEntityContractTextValue(entity: any): string {
    if (boolEntityOmitsContractText(entity)) {
        return "";
    }
    if (entity?.hideNameInDocument) {
        return boolEntityLabel(entity);
    }
    return boolEntityTextValue(entity);
}

export function isBoolEntityEmpty(entity: any): boolean {
    if (!boolEntityRequiresChecked(entity)) {
        return false;
    }
    return !isBoolEntityChecked(entity.value);
}
